import { createAction } from "@reduxjs/toolkit";
import { CHAT_ACTIONS } from "../../types";
import type { MessageFile } from "../../types";

export const updateFileMessage = createAction(
  CHAT_ACTIONS.UPDATE_MESSAGE_FILE,
  (message: MessageFile) => ({ payload: { message } })
);
